/**
 * Кадр на отправку живёт ЗДЕСЬ, а не в Redux: `File` не сериализуется, и в
 * аргументе запроса он попал бы в action и кэш мутации (десять мегабайт в
 * devtools). В аргумент уходит только `frameId`; кадр снимается, когда запрос
 * закончился. Это не состояние приложения, а вложение одного запроса.
 */
const frames = new Map<string, Blob>()
let counter = 0

export function holdFrame(frame: Blob): string {
  counter += 1
  const id = `frame-${counter}`
  frames.set(id, frame)
  return id
}

export const peekFrame = (id: string): Blob | undefined => frames.get(id)

export function releaseFrame(id: string): void {
  frames.delete(id)
}

/**
 * Кадр последнего поиска - для кнопки «Повторить»: тот же кадр уходит ещё раз, человеку не нужно снимать или выбирать заново. Живёт в
 * памяти вкладки до следующего снимка. Сервер кадр не хранит, поэтому повтор отправляет его снова.
 */
let retryPhoto: File | null = null
export const rememberRetryPhoto = (photo: File): void => {
  retryPhoto = photo
}
export const lastRetryPhoto = (): File | null => retryPhoto

/**
 * Последний отправленный снимок — для показа вверху выдачи (RP-FB26): человек видит, что ушло в поиск и какого
 * качества кадр. Срок `screen`: живёт в памяти вкладки до следующего снимка, прежний адрес освобождается.
 */
let sentShot: string | null = null
const shotListeners = new Set<() => void>()

export function rememberSentShot(frame: Blob): void {
  if (sentShot !== null && typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(sentShot)
  sentShot = typeof URL.createObjectURL === 'function' ? URL.createObjectURL(frame) : null
  for (const listener of shotListeners) listener()
}

export const sentShotUrl = (): string | null => sentShot

export function onSentShot(listener: () => void): () => void {
  shotListeners.add(listener)
  return () => shotListeners.delete(listener)
}
